import updateCancelPolicy from "../../../../actions/siteadmin/CancellationPolicy/updateCancelPolicy";
import {
  inputTextLimit,
  containsMalicious,
  cleanInput,
} from "../../../../helpers/textRestriction";
import showToaster from "../../../../helpers/showToaster";

async function submit(values, dispatch) {
  // Clone the values to avoid mutating the original immutable object
  const cleanedValues = { ...values };

  const fieldsToValidate = [
    "policyName",
    "policyContent",
    "subTitle",
    "subContent",
    "content1",
    "content2",
    "content3",
  ];

  const maxLength = 5000;

  for (const field of fieldsToValidate) {
    let value = cleanedValues[field];

    if (!value || value.trim() === "") {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      return Promise.reject();
    }

    value = cleanInput(value);

    if (containsMalicious(value)) {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      return Promise.reject();
    }

    if (value.length > maxLength) {
      showToaster({ messageId: "invalidInput", toasterType: "error" });
      return Promise.reject();
    }

    cleanedValues[field] = value; // safe to assign now
  }

  // Dispatch with cleaned values
  return dispatch(updateCancelPolicy(cleanedValues));
}

export default submit;
